// extracted by mini-css-extract-plugin
export default {"loadingWrapper":"Loading-module--loading-wrapper--2309e"};